// extracted by mini-css-extract-plugin
export default {"container":"ColorectalCancerScreening_container__qYgyI","back-btn":"ColorectalCancerScreening_back-btn__YVVeT","back-icon":"ColorectalCancerScreening_back-icon__UT64I"};